<!-- solicitud-detalle.component.html -->
<h2>Detalle de Solicitud</h2>
<mat-dialog-content class="mat-typography">
    <div class="detalle-solicitud">  
        <div>
            <p><strong>Monto: </strong></p>
            <p>{{ data.monto }}</p>
        </div>
        <div>
            <p><strong>Duración:</strong></p>
            <p>{{ data.duracion }} meses</p>
        </div>
        <div>
            <p><strong>Estado:</strong></p> 
            <p>{{ data.estadoSolicitudCredito }}</p>
        </div>  
    </div>
    <!-- Agrega más detalles según tu modelo de solicitud -->

    <button mat-raised-button color="primary" (click)="cerrar()">Cerrar</button>
</mat-dialog-content>
